import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { PwaInstaller } from "./lib/installprompt";
import * as serviceWorker from './serviceWorker';

import { enableAnalyticsIfConsented } from "./lib/analytics";

if (window.matchMedia('(display-mode: standalone)').matches) {
  PwaInstaller.IsInstalled = true;
}

window.addEventListener("beforeinstallprompt", function (beforeInstallPromptEvent) {
  beforeInstallPromptEvent.preventDefault(); // Prevents immediate prompt display
  PwaInstaller.setexecuteDeferredPrompt(beforeInstallPromptEvent);
});

function isStandalone() {
  return !!navigator.standalone || window.matchMedia('(display-mode: standalone)').matches;
}

function exitsOnBack() {
  //return isStandalone() && browserInfo.os.name === 'Android';
  return isStandalone();
}

if (exitsOnBack()) {
  handleBackEvents();
}

function handleBackEvents() {
  window.history.pushState({}, '');

  window.addEventListener('popstate', () => {
    setTimeout(() => {
      window.history.pushState({}, '');
    }, 2000);
  });
}

serviceWorker.register();

// Nur wenn bereits zugestimmt wurde. Die Erstzustimmung löst der
// Cookie-Banner in home.js aus.
enableAnalyticsIfConsented();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

